exports.lang = {
    "kr": "en",
    "아프리카TV | 투표" : "AfreecaTV | Vote",
    "투표" : "Vote",
    "투표 등록" : "Register Vote",
    "투표 수정" : "Edit Vote",
    "투표 등록 및 수정" : "Register and Edit Vote",
    "종류" : "Type",
    "기본형" : "Basic",
    "1\:1 투표" : "1v1 Vote",
    "제목" : "Title",
    "투표 제목을 입력해주세요." : "Please enter a title. ",
    "항목을 입력해주세요." : "Please enter an option.",
    "기간" : "Period",
    "투표 종료일" : "Vote End Date",
    "종료일" : "End Date",
    "설정" : "Settings",
    "복수 선택 허용" : "Allow Multi-select",
    "결과 미리보기 허용" : "Allow Preview",
    "체크 박스를 해제하시면 투표에 참여하기 전 또는 투표가 종료될 때까지 모든 참여자가 투표 결과를 확인할 수 없습니다." : "If you disable the checkbox, users cannot view the result before participating or voting ends.",
    "수정" : "Edit",
    "닫기" : "Close",
    "삭제" : "Delete",
    "등록" : "Register",
    "투표 항목을 입력해주세요." : "Please enter an option.",
    "투표 항목은 최소 2개 이상 등록해야 합니다." : "You must enter at least 2 options.",
    "투표는 최대 3개까지 등록할 수 있습니다." : "You can register up to 3 votes. ",
    "투표 항목은 최대 10개까지 만들 수 있습니다." : "You can create up to 10 options. ",
    "투표 제목은 최대 30자까지 입력할 수 있습니다." : "You can enter up to 60 characters for a title.",
    "투표 항목은 최대 10자까지 입력할 수 있습니다." : "You can enter up to 20 characters for an option.",
    "올바른 파일 형식이 아닙니다.\n파일 확장명이 JPG, GIF 인지 다시 확인해주세요." : "Invalid file type. Please check again if the file extension either JPG or GIF.",
    "파일 용량이 10MB을(를) 초과하여 등록할 수 없습니다." : "The file cannot be registered as the file size exceeds 10MB.",
    "선택하신 GIF 파일 용량이 200KB를 초과하여 등록할 수 없습니다. 파일 용량을 다시 확인해주세요." : "The selected GIF file cannot be registered as the file size exceeds 200KB. Please check the file size again.",
    "투표 기간을 설정해주세요." : "Please set the voting period.",
    "오늘보다 이전 날짜 또는 시간은 설정할 수 없습니다." : "You cannot set a date or time before today.",
    "입력하신 내용이 모두 초기화됩니다. 투표 형식을 변경하시겠습니까?" : "All entries will be initialized. Would you like to change the voting format?",
    "투표가 수정되었습니다." : "Edited",
    "투표를 삭제하시겠습니까?" : "Would you like to delete the vote?",
    "해당 투표 항목을 삭제하시겠습니까?" : "Would you like to delete this option?",
    "투표하기" : "Vote",
    "결과 미리보기" : "Preview",
    "다시 투표하기" : "Vote Again",
    "전체 참여자" : "Total Participants",
    "명" : "",
    "투표하러 가기" : "Go Vote",
    "현재시간 이후를 선택해주세요." : "Please select the time after the current time",
    "투표 종료일을 3개월 이내로 선택해주세요." : "Please select the vote end date within the next 3 months",
    "투표가 등록되었습니다." : "You have registered a vote.",
    "투표를 등록한 유저가 삭제한 투표입니다" : "The voting has been deleted by its registerer.",
    "다른 투표에 참여해주세요." : "Please participate in another voting.",
    "투표에 참여 완료되었습니다." : "You have successfully voted.",
    "투표 종료" : "End Vote",
    "투표를 종료하시겠습니까?" : "Would you like to end voting?",
    "항목 추가" : "Add Item",
    "취소" : "Cancel",
    "시" : "",
    "분" : "",
    "이미지 1:1 투표 등록 시, 투표 이미지를 모두 첨부하셔야 등록할 수 있습니다.": "When registering for Image 1:1 Vote, you need to attach both images to proceed.",
    "무승부" : "Draw",
    "무승부 항목 추가" : "add a draw",
}